import React, { useState } from 'react';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
  DropdownMenuCheckboxItem, DropdownMenuSeparator, DropdownMenuLabel
} from "./dropdown-menu"; // Assuming you export your components from here
import { IoIosArrowDown } from 'react-icons/io';
import { Label } from './label';
import { Button } from './button';

const AdvancedDropdown = ({ label=true,options, selectedOptions, setSelectedOptions, placeholder, id, name, select, disabled = false,required=false }) => {
  const [searchValue, setSearchValue] = useState("");

  const handleSelectOption = (option) => {
    if (select === 'single') {
      // For single selection, set the selected option directly
      setSelectedOptions([option]);
    } else {
      // For multiple selection, toggle the selected option
      setSelectedOptions((prevSelected) =>
        prevSelected.includes(option)
          ? prevSelected.filter((item) => item !== option)
          : [...prevSelected, option]
      );
    }
  };

  const handleRemoveOption = (option) => {
    if (select === 'multiple') {
      setSelectedOptions((prev) => prev.filter((item) => item !== option));
    }
  };

  const handleReset = () => {
    setSelectedOptions([]); // Reset selection to an empty array
  };
  

  const filteredOptions = options.filter(option =>
    option.toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <div className="flex flex-col w-full gap-2">
      {label && <Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor={id}>{name} {required && <span className=" text-red-600">*</span>} </Label>}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button id={id} variant="outline" size="lg" 

          disabled={disabled} // Disable button if dropdown is disabled
          aria-label={`${name || placeholder} selector`}
          aria-haspopup="menu"
  className={`h-10 gap-1 w-full text-md flex border-[#3a5dd1] rounded-md border justify-between items-center px-8 ${disabled ? 'bg-gray-200 cursor-not-allowed' : ''}`} // Add disabled styles
          >
            <span className="sr-only sm:not-sr-only">
        {selectedOptions.length > 0 
          ? select === "single" 
            ? selectedOptions[0]
            : `${selectedOptions.length} selected`
          : `Select ${name}`}
              </span>
              <IoIosArrowDown className={`ml-1 ${disabled ? 'text-gray-400' : 'text-[#0D215C]'}`} />

          </Button>
        </DropdownMenuTrigger>
       {
        !disabled &&
        <DropdownMenuContent className={`w-[var(--radix-dropdown-menu-trigger-width)] max-h-[300px]`}>
          <DropdownMenuLabel>{placeholder} Options</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <div className="p-2">
            <input
              type="text"
              value={searchValue}
              onChange={(e) => {
                e.stopPropagation(); // Prevent closing the dropdown
                setSearchValue(e.target.value);
              }}
              aria-label={`Search ${placeholder}`}
              placeholder={`Search ${placeholder}`}
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <DropdownMenuSeparator />
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <DropdownMenuCheckboxItem
                key={index}
                checked={select === 'single' ? selectedOptions[0] === option : selectedOptions.includes(option)}
                onClick={() =>
                {
                 
                  handleSelectOption(option)
                }
              }
              >
                {option}
              </DropdownMenuCheckboxItem>
            ))
          ) : (
            <p className="text-gray-500 p-2">No results found</p>
          )}
          {/* Reset option */}
          <DropdownMenuSeparator />
            <DropdownMenuCheckboxItem onClick={handleReset} className="text-red-500 font-bold">
              Reset Selection
            </DropdownMenuCheckboxItem>
        </DropdownMenuContent>}
      </DropdownMenu>
      <div 
  className={`w-full flex flex-wrap gap-4 ${disabled ? 'pointer-events-none opacity-50' : ''}`}
  aria-disabled={disabled} // For accessibility
>
  {select !== "single" && selectedOptions.length > 0 && selectedOptions.map((option, index) => (
    <div   key={index} className="flex gap-8 justify-center items-center bg-[#0D215C] text-white text-sm rounded-xl px-4 py-2 font-bold  ">
    <span>{option}</span>
    
   
      {select === 'multiple' && (


<div className="rounded-full bg-red-500  flex items-center justify-center h-5 w-5 p-1 text-xs cursor-default "
onClick={() => !disabled && handleRemoveOption(option)}
>{"X"}
</div>
        // <span
        //   className="text-sm font-bold cursor-pointer" 
        //   onClick={() => !disabled && handleRemoveOption(option)} // Disable the click event if disabled
        // >
        //   X
        // </span>
      )}
    </div>
  ))}
</div>

    </div>
  );
};

export default AdvancedDropdown;
